import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=6d88fba2&scoped=true"
import script from "./DialogForm.vue?vue&type=script&lang=js"
export * from "./DialogForm.vue?vue&type=script&lang=js"
import style0 from "./DialogForm.vue?vue&type=style&index=0&id=6d88fba2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88fba2",
  null
  
)

export default component.exports